import { IAuthUserContext } from 'contexts/types/authUserContext';

// Default data for init of context
const authUserContextDefault: IAuthUserContext = {
  authUser: null,
  isError: false,
  hasCapability: () => true,
};

export default authUserContextDefault;
